export const isDebugMode = () => {
  if (typeof window === 'undefined') return false;

  try {
    const params = new URLSearchParams(window.location.search);
    return params.has('__trk_inspect__');
  } catch {
    // fallback para ambientes sem URLSearchParams
    return window.location.search.indexOf('__trk_inspect__') !== -1;
  }
};

export function setCookie(name: string, value: string, days = 7) {
  const encodedValue = encodeURIComponent(value);

  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }

  document.cookie = `${name}=${encodedValue}${expires}; path=/;`;
}

export const paymentTypeMap = [
  ['vale', 'vale crédito'],
  ['pagaleve', 'pix'],
  ['pix parcel', 'pix parcelado'],
  ['pix', 'pix'],
  ['apple', 'apple pay'],
  ['google', 'google pay'],
  ['boleto', 'boleto'],
  ['paypal', 'paypal'],
  ['cred', 'cartão'],
  ['visa', 'cartão'],
  ['master', 'cartão'],
  ['amex', 'cartão'],
  ['elo', 'cartão'],
  ['hiper', 'cartão'],
  ['diner', 'cartão'],
  ['deb', 'cartão'],
];


export const toNum = (val: unknown) => typeof val === 'string' ? Number(val.replace(/[^\d,]/g, '').replace(',', '.')) : val

export const documentToHash = async (document: string | undefined): Promise<string | null> => {
  if (!document) return null

  const encoder = new TextEncoder();
  const data = encoder.encode(document);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));

  return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
}

const SIZE_ORDER: Record<string, string[]> = {
  alfabetico: ['PP', 'P', 'M', 'G', 'GG', 'XG', 'XGG', 'EG', 'EGG', '3G', '4G', '5G'],
  infantil: ['RN', '0-3M', '3-6M', '6-9M', '9-12M', '12-18M', '18-24M', 'P', 'M', 'G', 'GG'],
}

const detectSizeType = (sizes: string[]): 'alfabetico' | 'numerico' | 'infantil' | 'desconhecido' => {
  if (sizes.every(s => /^\d+([.,]\d+)?$/.test(s))) return 'numerico'
  if (sizes.some(s => /^(RN|\d+-\d+M|\d+M)$/i.test(s))) return 'infantil'
  if (sizes.every(s => SIZE_ORDER.alfabetico.includes(s.toUpperCase()))) return 'alfabetico'
  return 'desconhecido'
}

export const sortSizes = (sizes: string[]): string[] => {
  const unique = [...new Set(sizes.filter(Boolean))]
  const type = detectSizeType(unique)

  if (type === 'numerico') {
    return unique.sort((a, b) => parseFloat(a) - parseFloat(b))
  }

  if (type === 'alfabetico' || type === 'infantil') {
    const order = SIZE_ORDER[type]
    return unique.sort((a, b) => {
      const ia = order.indexOf(a.toUpperCase())
      const ib = order.indexOf(b.toUpperCase())
      return (ia === -1 ? 999 : ia) - (ib === -1 ? 999 : ib)
    })
  }

  return unique
}

export const capitalize = (str: string): string => str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : "";

export const resizeVtexImage = (url: string | undefined, width = 500, height = 500) => {
  return url?.replace(
    /(\/arquivos\/ids\/\d+)-\d+-\d+\//,
    `$1-${width}-${height}/`
  );
}
